module.exports = __webpack_public_path__ + "img/pay_under_contract_min.c1312970.jpg";